// src/Layouts/Header.tsx
import React from 'react';
import './Footer.css'; // Importér styling til headeren
import logo from '../Images/logo.png'; 

const Header: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <img src={logo} alt="Badminton Danmark Logo" />
                </div>
                <div className="footer-address">
                    <h4>ADRESSE:</h4>
                    <p>IDRÆTTENS HUS<br />Brøndby Stadion 20, DK-2605 Brøndby</p>
                    <h4>ÅBNINGSTIDER:</h4>
                    <p>Mandag – Torsdag: 09:00 – 16:00<br />Fredag: 09:00 – 15:30</p>
                </div>
                <div className="footer-contact">
                    <h4>KONTAKT OS:</h4>
                    <p>event@badminton.dk<br />+45 70 60 50 76</p>
                    <h4>FØLG OS:</h4>
                    <div className="footer-social-icons">
                        {/* Sociale ikoner */}
                        <a href="#"><i className="fab fa-facebook"></i></a>
                        <a href="#"><i className="fab fa-twitter"></i></a>
                        <a href="#"><i className="fab fa-linkedin"></i></a>
                        <a href="#"><i className="fab fa-youtube"></i></a>
                        <a href="#"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <p className="footer-copyright">Copyright © 2026 Badminton Danmark</p>
        </footer>
    );
};

export default Header;
